module.exports = __webpack_public_path__ + "img/H3.0c26e062.jpg";